import { render } from "./mailSentLog.vue?vue&type=template&id=9cadad08&ts=true"
import script from "./mailSentLog.vue?vue&type=script&lang=ts"
export * from "./mailSentLog.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__